import DataTable from 'components/miscellaneous/DataTable/DataTable';
import moment from 'moment';

const ApplicatorsTable = ({applicators, isStandalone}) => {
    return (
        <div className='table'>
            <DataTable headers={[

                {name: 'Applicator ID', id: 'handle_id'},
                {name: 'Applicator Name', id: 'name'},
                {name: 'Clinic Name', id: 'clinic_name'},
                {name: 'Pulses', id: 'pulses', render: (pulses) => pulses.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")},
                {name: 'Date Added', id: 'created_at', render: (date) => moment(date).format('ll')},
            ]} data={applicators} pagination={null} maxHeight={isStandalone ? '100%' : '300px'} />
        </div>
    )
}

export default ApplicatorsTable;